import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
};

var _client, _pollInterval, _verbose;

import fetch from 'isomorphic-unfetch';
import { Client, createRequest as createRequestUrql } from '@urql/core';
import { pipe, subscribe } from 'wonka'; // Average block time is about 13 seconds on the 2020-08-14
// See https://etherscan.io/chart/blocktime

var POLL_INTERVAL_DEFAULT = 13 * 1000;

function createRequest(query, args) {
  // Make every operation type a query, until GraphQL subscriptions get added again.
  if (query.definitions) {
    query = _objectSpread({}, query, {
      definitions: query.definitions.map(function (definition) {
        return _objectSpread({}, definition, {
          operation: 'query'
        });
      })
    });
  }

  return createRequestUrql(query, args);
}

var GraphQLWrapper =
/*#__PURE__*/
function () {
  function GraphQLWrapper(subgraphUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, GraphQLWrapper);

    var _a, _b;

    _client.set(this, void 0);

    _pollInterval.set(this, void 0);

    _verbose.set(this, void 0);

    if (typeof options === 'boolean') {
      console.warn('GraphQLWrapper: please use `new GraphQLWrapper(url, { verbose })` rather than `new GraphQLWrapper(url, verbose)`.');
      options = {
        verbose: options
      };
    }

    options = options;

    __classPrivateFieldSet(this, _verbose, (_a = options.verbose) !== null && _a !== void 0 ? _a : false);

    __classPrivateFieldSet(this, _pollInterval, (_b = options.pollInterval) !== null && _b !== void 0 ? _b : POLL_INTERVAL_DEFAULT);

    __classPrivateFieldSet(this, _client, new Client({
      maskTypename: true,
      url: subgraphUrl,
      fetch: fetch
    }));
  }

  _createClass(GraphQLWrapper, [{
    key: "close",
    value: function close() {// Do nothing for now.
      // Will be used when GraphQL subscriptions will be added again.
    }
  }, {
    key: "subscribeToQuery",
    value: function subscribeToQuery(query) {
      var _this = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var request = createRequest(query, args);
      return pipe(__classPrivateFieldGet(this, _client).executeQuery(request, {
        pollInterval: __classPrivateFieldGet(this, _pollInterval),
        requestPolicy: 'cache-and-network'
      }), subscribe(function (result) {
        if (__classPrivateFieldGet(_this, _verbose)) {
          console.log(_this.describeQueryResult(result));
        }

        if (result.error) {
          throw new Error(['Error performing subscription.', "".concat(result.error.name, ": ").concat(result.error.message), _this.describeQueryResult(result)].join('\n'));
        }

        callback(result);
      }));
    }
  }, {
    key: "subscribeToQueryWithParser",
    value: function subscribeToQueryWithParser(query) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var parser = arguments.length > 3 ? arguments[3] : undefined;
      return this.subscribeToQuery(query, args,
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(result) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = callback;
                  _context.next = 3;
                  return _this2.parseQueryResult(parser, result);

                case 3:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "performQuery",
    value: function () {
      var _performQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(query) {
        var args,
            result,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return __classPrivateFieldGet(this, _client).query(query, args).toPromise();

              case 3:
                result = _context2.sent;

                if (__classPrivateFieldGet(this, _verbose)) {
                  console.log(this.describeQueryResult(result));
                }

                if (!result.error) {
                  _context2.next = 7;
                  break;
                }

                throw new Error(this.describeQueryResultError(result) + this.describeQueryResult(result));

              case 7:
                return _context2.abrupt("return", result);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function performQuery(_x2) {
        return _performQuery.apply(this, arguments);
      }

      return performQuery;
    }()
  }, {
    key: "performQueryWithParser",
    value: function () {
      var _performQueryWithParser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(query) {
        var args,
            parser,
            result,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                args = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                parser = _args3.length > 2 ? _args3[2] : undefined;
                _context3.next = 4;
                return this.performQuery(query, args);

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", this.parseQueryResult(parser, result));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function performQueryWithParser(_x3) {
        return _performQueryWithParser.apply(this, arguments);
      }

      return performQueryWithParser;
    }()
  }, {
    key: "parseQueryResult",
    value: function () {
      var _parseQueryResult = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(parser, result) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                return _context4.abrupt("return", parser(result));

              case 4:
                _context4.prev = 4;
                _context4.t0 = _context4["catch"](0);
                throw new Error(_context4.t0.message + '\n\n' + this.describeQueryResult(result));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 4]]);
      }));

      function parseQueryResult(_x4, _x5) {
        return _parseQueryResult.apply(this, arguments);
      }

      return parseQueryResult;
    }()
  }, {
    key: "describeQueryResultError",
    value: function describeQueryResultError(result) {
      if (!result.error) {
        return '';
      }

      return "".concat(result.error.name, ": ").concat(result.error.message, "\n\n");
    }
  }, {
    key: "describeQueryResult",
    value: function describeQueryResult(result) {
      var _a;

      var queryStr = (_a = result.operation.query.loc) === null || _a === void 0 ? void 0 : _a.source.body;
      var dataStr = JSON.stringify(result.data, null, 2);
      var argsStr = JSON.stringify(result.operation.variables, null, 2);
      var subgraphUrl = result.operation.context.url;
      return ["Subgraph: ".concat(subgraphUrl), "Arguments: ".concat(argsStr), "Query: ".concat(queryStr), "Returned data: ".concat(dataStr)].join('\n\n');
    }
  }]);

  return GraphQLWrapper;
}();

export { GraphQLWrapper as default };
_client = new WeakMap(), _pollInterval = new WeakMap(), _verbose = new WeakMap();